import { Result } from "../../models/result";

export function sortNameAscending(a: Result, b: Result) {
	if (a === undefined || b === undefined) {
		return 0;
	}

	//TODO: Adjust to marketing name
	if (a.title < b.title) {
		return -1;
	}
	if (a.title > b.title) {
		return 1;
	}

	return 0;
}
